// extracted by mini-css-extract-plugin
module.exports = {"control":"Select_control__ST2Rr","primary":"Select_primary__rI8uU","default":"Select_default__7Az42"};